export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "add-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Merchant Management"])},
        "empty-list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No merchants have been created yet."])},
        "create-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a merchant"])},
        "market-count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize([_interpolate(_named("count")), " merchant"]), _normalize([_interpolate(_named("count")), " merchants"])])},
        "search-placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search by merchant name, email address, person name"])}
      },
      "fr": {
        "add-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des commerces"])},
        "empty-list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun commerce n'a encore été créé."])},
        "create-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer un commerce"])},
        "market-count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize([_interpolate(_named("count")), " commerce"]), _normalize([_interpolate(_named("count")), " commerces"])])},
        "search-placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher par nom du commerce, addresse courriel, nom de la personne"])}
      }
    }
  })
}
